import { Component, ViewChild, TemplateRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'uex-action-bar',
  templateUrl: './action-bar.component.html'
})
export class ActionBarComponent implements OnInit {
  @ViewChild(TemplateRef, { static: true }) content: TemplateRef<any>;

  @Input('class') cssClass: any;
  @Input('top') _top: string;
  @Input('bottom') _bottom: string;

  constructor() { }

  public is_top = false;
  public is_bottom = false;

  ngOnInit() {
    if (this._top == '') { this.is_top = true; }
    if (this._bottom == '') { this.is_bottom = true; }
  }
}
